import React, { useState } from 'react';
import { Tabs } from 'antd';
import { CalendarOutlined, ControlOutlined } from '@ant-design/icons';

import { useAccess } from '../../auth/AccessContext.jsx';
import FundConfig from './FundConfig.jsx';
import CalendarPanel from './CalendarPanel.jsx';

/** Section tab comes from the second hash segment: `#settings/calendar`. No window (a server render): the first tab. */
const sectionFromHash = (keys) => {
    const hash = typeof window === 'undefined' ? '' : window.location.hash;
    const key = hash.replace('#', '').split('/')[1];
    return keys.includes(key) ? key : keys[0];
};

/**
 * Settings — fund config and the dealing calendar, across the top. A tab shows
 * only when the Core granted its screen. Fund config is where a fund's fees are
 * read, proposed, approved and rejected (IP-98..IP-102; FundConfig.jsx):
 * SettingsTab.test.js renders it under each claim that opens it.
 */
const SettingsTab = () => {
    const { canView } = useAccess();
    const allTabs = [
        { key: 'fundConfig', icon: <ControlOutlined />, label: 'Fund config' },
        { key: 'calendar', icon: <CalendarOutlined />, label: 'Calendar' }
    ];
    const tabItems = allTabs.filter((tab) => canView(tab.key));
    const [section, setSection] = useState(() => sectionFromHash(tabItems.map((tab) => tab.key)));

    const sections = {
        fundConfig: <FundConfig />,
        calendar: <CalendarPanel />
    };

    return (
        <div className="workspace">
            <Tabs
                className="workspace-tabs"
                activeKey={section}
                onChange={(key) => {
                    setSection(key);
                    window.location.hash = `settings/${key}`;
                }}
                items={tabItems}
            />
            <div className="workspace-body">{sections[section]}</div>
        </div>
    );
};

export default SettingsTab;
